import { Container } from '@mentalgrowth/ui-kit-web';
import type { TpContainerProps } from '@mentalgrowth/ui-kit-web';
export const UiKitContainer = (props: TpContainerProps) => <Container {...props} data-sentry-element="Container" data-sentry-component="UiKitContainer" data-sentry-source-file="index.tsx" />;